module.exports = __webpack_public_path__ + "static/img/1.79948cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/eng/1.png
// module id = lnea
// module chunks = 0